// extracted by mini-css-extract-plugin
export var RecruitEntry = "RecruitEntry-module--RecruitEntry--3Iyhg";
export var RecruitEntry__inner = "RecruitEntry-module--RecruitEntry__inner--2LhJw";
export var RecruitEntry__content = "RecruitEntry-module--RecruitEntry__content--26Ytg";
export var RecruitEntry__contentTop = "RecruitEntry-module--RecruitEntry__contentTop--2vSYU";
export var RecruitEntry__contentBtm = "RecruitEntry-module--RecruitEntry__contentBtm--1PiVz";
export var RecruitEntry__contact = "RecruitEntry-module--RecruitEntry__contact--2KcHg";
export var RecruitEntry__contactIcon = "RecruitEntry-module--RecruitEntry__contactIcon--1JW2j";
export var RecruitEntry__contactmynavi = "RecruitEntry-module--RecruitEntry__contactmynavi--kiOlc";
export var RecruitEntry__contactText = "RecruitEntry-module--RecruitEntry__contactText--2xZeM";